var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel" }, [
    _c("div", { staticClass: "panel-hdr" }, [
      _c("h2", [
        _vm._m(0),
        _vm._v("\n\t\t\t\t" + _vm._s(_vm.__t("REGISTRATION")) + "\n\t\t\t"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "panel-container show" }, [
      _c("div", { staticClass: "panel-content mb-0" }, [
        _c("div", { staticClass: "user_auth" }, [
          _c("form", { staticClass: "user", attrs: { autocomplete: "off" } }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("b-form-input", {
                  staticClass: "form-control form-control-use",
                  attrs: {
                    state: _vm.username_state,
                    id: "input-live-feedback_username",
                    placeholder: _vm.__t("USER_LOGIN"),
                  },
                  model: {
                    value: _vm.user_form.username,
                    callback: function ($$v) {
                      _vm.$set(_vm.user_form, "username", $$v)
                    },
                    expression: "user_form.username",
                  },
                }),
                _vm._v(" "),
                _c(
                  "b-form-invalid-feedback",
                  { attrs: { id: "input-live-feedback" } },
                  [
                    _vm._v(
                      "\n                                " +
                        _vm._s(_vm.__t("MIN_3_SYMBOLS")) +
                        "\n\t\t\t\t\t\t\t"
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "phone form-group" },
              [
                _c("the-mask", {
                  ref: "phone_inp",
                  staticClass: "form-control form-control-user",
                  class: {
                    "is-invalid": !_vm.is_phone_ok,
                    fill: _vm.is_phone_ok,
                  },
                  attrs: {
                    mask: ["+## (###) ###-##-##", "+## (###) ###-##-##"],
                    id: "my-phone",
                    type: "text",
                    placeholder: _vm.__t("USER_PHONE"),
                    masked: false,
                  },
                  model: {
                    value: _vm.user_form.phone,
                    callback: function ($$v) {
                      _vm.$set(_vm.user_form, "phone", $$v)
                    },
                    expression: "user_form.phone",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("b-form-input", {
                  staticClass: "form-control form-control-user",
                  attrs: {
                    state: _vm.userpass_state,
                    id: "user_pass_register",
                    type: _vm.field_type.pass,
                    placeholder: _vm.__t("PASSWORD"),
                  },
                  model: {
                    value: _vm.user_form.password,
                    callback: function ($$v) {
                      _vm.$set(_vm.user_form, "password", $$v)
                    },
                    expression: "user_form.password",
                  },
                }),
                _vm._v(" "),
                _c("b-form-invalid-feedback", { attrs: { id: "user_pass" } }, [
                  _vm._v(
                    "\n                                " +
                      _vm._s(_vm.__t("MIN_6_SYMBOLS")) +
                      "\n\t\t\t\t\t\t\t"
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn btn-success btn-user btn-block",
                    on: { click: _vm.make_register },
                  },
                  [
                    _vm._v(
                      "\n                                " +
                        _vm._s(_vm.__t("REGISTRATION")) +
                        "\n\t\t\t\t\t\t\t"
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon-stack fs-xxl mr-2" }, [
      _c("i", {
        staticClass: "base base-7 icon-stack-3x opacity-100 color-primary-500",
      }),
      _vm._v(" "),
      _c("i", {
        staticClass: "base base-7 icon-stack-2x opacity-100 color-primary-400",
      }),
      _vm._v(" "),
      _c("i", {
        staticClass:
          "fal fa-sync icon-stack-1x opacity-100 color-white fa-spin",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }